import script from "./WhCodeScan.vue?vue&type=script&setup=true&lang=js"
export * from "./WhCodeScan.vue?vue&type=script&setup=true&lang=js"

export default script